module.exports = __webpack_public_path__ + "img/bg-banner.1f23c6f5.png";